/* Brand logo — inline SVG inspired by the uploaded reference (circular mark + "GIFT TO CASH" wordmark)
   but compact like the original chip+wordmark layout. Color adapts via the `variant` prop. */

export default function Logo({ className = "h-9", variant = "auto", testId = "brand-logo" }) {
    // variant: "light" -> dark text (for white/light backgrounds)
    //          "dark"  -> white text (for navy/dark backgrounds)
    //          "auto"  -> uses currentColor; parent decides via text-* class
    const isDark = variant === "dark";
    const isLight = variant === "light";
    const wordColor = isDark ? "#FFFFFF" : isLight ? "#0F1729" : "currentColor";
    const subColor = isDark ? "rgba(255,255,255,0.65)" : isLight ? "#64748B" : "currentColor";

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 224 56"
            className={`${className} w-auto select-none`}
            data-testid={testId}
            aria-label="GiftToCash"
            role="img"
        >
            {/* Icon: green disc with stylized G + exchange arrows */}
            <g>
                <circle cx="28" cy="28" r="26" fill="#10B981" />
                <circle cx="28" cy="28" r="26" fill="url(#logo-grad)" opacity="0.35" />
                {/* G letter */}
                <path
                    d="M37.5 21.2c-1.7-2.7-4.7-4.5-8.1-4.5-5.3 0-9.5 4.3-9.5 9.5 0 5.3 4.3 9.5 9.5 9.5 4.7 0 8.6-3.4 9.4-7.9h-9.4v-3.7h13.6c.1.5.1 1 .1 1.6 0 7.5-6.1 13.6-13.6 13.6S15.9 33.2 15.9 25.7s6.1-13.6 13.6-13.6c4.4 0 8.3 2.1 10.8 5.4l-2.8 3.7Z"
                    fill="#FFFFFF"
                />
                {/* small exchange arrow accent */}
                <path
                    d="M40 40.5l-2.4-2.4 1.6-1.6h-3.6v-2.3h3.6l-1.6-1.6 2.4-2.4 5.5 5.5-5.5 4.8Z"
                    fill="#FBBF24"
                />
            </g>

            {/* Wordmark */}
            <text
                x="64"
                y="26"
                fill={wordColor}
                fontFamily="Outfit, Inter, sans-serif"
                fontWeight="800"
                fontSize="20"
                letterSpacing="1.2"
            >
                GIFT TO CASH
            </text>
            <text
                x="64"
                y="44"
                fill={subColor}
                fontFamily="Inter, sans-serif"
                fontWeight="500"
                fontSize="9"
                letterSpacing="3"
            >
                INSTANT EXCHANGE
            </text>

            <defs>
                <linearGradient id="logo-grad" x1="0" x2="1" y1="0" y2="1">
                    <stop offset="0%" stopColor="#34D399" />
                    <stop offset="100%" stopColor="#059669" />
                </linearGradient>
            </defs>
        </svg>
    );
}
